import type { ConvertAction } from "../api/convertLead.types";

/** Plain-English outcome for each convert action. */
const ACTION_SUMMARIES: Record<ConvertAction, string> = {
  create: "Creating new",
  reuse: "Using existing",
  link: "Attaching existing",
  skip: "Not included",
};

export function convertActionLabel(action: ConvertAction | string | undefined): string {
  if (action === "create" || action === "reuse" || action === "link" || action === "skip") {
    return ACTION_SUMMARIES[action];
  }
  return action ? String(action) : "—";
}

export function formatPreviewAddress(location: {
  street_address?: string;
  city?: string;
  state_or_region?: string;
  postal_code?: string;
  country?: string;
}): string {
  const cityLine = [
    location.city,
    location.state_or_region && location.postal_code
      ? `${location.state_or_region} ${location.postal_code}`.trim()
      : location.state_or_region || location.postal_code,
    location.country,
  ]
    .filter(Boolean)
    .join(", ");

  return [location.street_address, cityLine].filter(Boolean).join(", ") || "—";
}

export function linkLabel(link: string): string {
  switch (link) {
    case "ClientContact":
      return "Add this contact to the client";
    case "TaskContact":
      return "Add this contact to the task";
    default:
      return link;
  }
}

/** One clear sentence for non-technical users. */
export function linksSummary(links: string[]): string | null {
  if (!links.length) return null;

  const hasClient = links.includes("ClientContact");
  const hasTask = links.includes("TaskContact");

  if (hasClient && hasTask) {
    return "This person will be saved on both the client and the task.";
  }
  if (hasClient) {
    return "This person will be saved on the client.";
  }
  if (hasTask) {
    return "This person will be saved on the task.";
  }

  return links.map((link) => linkLabel(link)).join(" · ");
}
